import { FunctionComponent, useMemo } from 'react';
import { CloseSolidIcon } from '../../../Icons';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { IconSummary } from '../IconSummary';

export type CancellationProps = {
    educator: PublicEducator;
    course: PublicCourse;
};

export const Cancellation: FunctionComponent<CancellationProps> = ({ educator, course }) => {
    const period = useMemo(() => {
        if (educator.cancellation_allowed === 1) {
            return 'day';
        }

        return 'days';
    }, [educator]);

    if (!educator || !educator.cancellation_allowed || course.type === 'on-demand') {
        return null;
    }

    return (
        <div>
            <IconSummary Icon={CloseSolidIcon}>
                Free cancellation {educator.cancellation_allowed} {period} prior
            </IconSummary>
        </div>
    );
};
